const { Panel, PanelBody, PanelRow, Card, CardHeader, CardBody, Button, ToggleControl, Spinner } = wp.components
const { render, useState, useEffect } = wp.element
import { __experimentalSpacer as Spacer } from '@wordpress/components';
const { __ } = wp.i18n
const { escapeHTML } = wp.escapeHtml
const { api } = wp;

const ThemeWingAdmin = () =>  {
	const [ hasServices, setHasServices ] = useState( false );
	const [ hasTeam, setHasTeam ] = useState( false );
	const [ hasPricing, setHasPricing ] = useState( false );
	const [ hasProjects, setHasProjects ] = useState( false );
	const [ settings, setSettings ] = useState( false );
	const [ isAPILoaded, setIsAPILoaded ] = useState( false );
	const [ saveText, setSaveText ] = useState( __( escapeHTML( 'Save Settings' ), 'theme-wing' ) );
	const [ saving, setSaving ] = useState(false);
	const [ buttonVariant, setButtonVariant ] = useState('primary');

	useEffect(() => {
		api.loadPromise.then( () => {
            const settingMethods = new api.models.Settings()
            if ( isAPILoaded === false ) {
                settingMethods.fetch().then( ( response ) => {
                    setSettings(JSON.parse( response['theme_wing_admin_option'] ) )
                    setIsAPILoaded(true)
                });
            }
        });
	},[])

	useEffect(() => {
		if( settings != false ) {
        	setHasServices(settings.includes('tw-services'))
        	setHasTeam(settings.includes('tw-team'))
        	setHasPricing(settings.includes('tw-pricing'))
        	setHasProjects(settings.includes('tw-projects'))
        }
	}, [settings])

	const onSaveSetting= () => {
		setSaveText( __( escapeHTML( 'Saving Settings' ), 'theme-wing' ) )
		setSaving(true)
		setButtonVariant('tertiary')
		const value = []
		if( hasServices ) value.push( 'tw-services' )
		if( hasTeam ) value.push( 'tw-team' )
		if( hasPricing ) value.push( 'tw-pricing' )
		if( hasProjects ) value.push( 'tw-projects' )
		const settingSave = new api.models.Settings({
			['theme_wing_admin_option'] : JSON.stringify(value)
		})
		settingSave.save().then(()=>{
			setSaveText( __( escapeHTML( 'Save Settings' ), 'theme-wing' ) )
			setSaving(false)
			setButtonVariant('primary')
		})
	}

	return (
		<>
			<Panel header={ __( escapeHTML( 'Admin General Settings' ), 'theme-wing' ) }>
		        <PanelBody title={ __( escapeHTML( 'Posts Types' ), 'theme-wing' ) } initialOpen={ true }>
		        	<Spacer>
			            <Card>
				            <CardHeader>
				                { __( escapeHTML( 'Services - Custom Post Type' ), 'theme-wing' ) }
				            </CardHeader>
				            <CardBody>
				                <ToggleControl
						            label={ __( escapeHTML( 'Register services custom post type' ), 'theme-wing' ) }
						            help={
						                hasServices
						                    ? __( escapeHTML( 'Currently registered and showing on dashboard' ), 'theme-wing' )
						                    : __( escapeHTML( 'Currently not registered' ), 'theme-wing' )
						            }
						            disabled={saving}
						            checked={ hasServices }
						            onChange={ () => {
						                setHasServices( ( state ) => ! state );
						            } }
						        />
				            </CardBody>
				        </Card>
			        </Spacer>

			        <Spacer>
				        <Card>
				            <CardHeader>
				                { __( escapeHTML( 'Team - Custom Post Type' ), 'theme-wing' ) }
				            </CardHeader>
				            <CardBody>
				                <ToggleControl
						            label={ __( escapeHTML( 'Register team custom post type' ), 'theme-wing' ) }
						            help={
						                hasTeam
						                    ? __( escapeHTML( 'Currently registered and showing on dashboard' ), 'theme-wing' )
						                    : __( escapeHTML( 'Currently not registered' ), 'theme-wing' )
						            }
						            disabled={saving}
						            checked={ hasTeam }
						            onChange={ () => {
						                setHasTeam( ( state ) => ! state );
						            } }
						        />
				            </CardBody>
				        </Card>
				    </Spacer>

				    <Spacer>
				        <Card>
				            <CardHeader>
				                { __( escapeHTML( 'Pricing - Custom Post Type' ), 'theme-wing' ) }
				            </CardHeader>
				            <CardBody>
				                <ToggleControl
						            label={ __( escapeHTML( 'Register pricing custom post type' ), 'theme-wing' ) }
						            help={
						                hasPricing
						                    ? __( escapeHTML( 'Currently registered and showing on dashboard' ), 'theme-wing' )
						                    : __( escapeHTML( 'Currently not registered' ), 'theme-wing' )
						            }
						            disabled={saving}
						            checked={ hasPricing }
						            onChange={ () => {
						                setHasPricing( ( state ) => ! state );
						            }}
						        />
				            </CardBody>
				        </Card>
				    </Spacer>

				    <Spacer>
				        <Card>
				            <CardHeader>
				                { __( escapeHTML( 'Projects - Custom Post Type' ), 'theme-wing' ) }
				            </CardHeader>
				            <CardBody>
				                <ToggleControl
						            label={ __( escapeHTML( 'Register projects custom post type' ), 'theme-wing' ) }
						            help={
						                hasProjects
						                    ? __( escapeHTML( 'Currently registered and showing on dashboard' ), 'theme-wing' )
						                    : __( escapeHTML( 'Currently not registered' ), 'theme-wing' )
						            }
						            disabled={saving}
						            checked={ hasProjects }
						            onChange={ () => {
						                setHasProjects( ( state ) => ! state );
						            } }
						        />
				            </CardBody>
				        </Card>
				    </Spacer>
		        </PanelBody>
	    	</Panel>
	    	<Panel>
		    	<PanelBody>
		        	<Button icon={ `cloud-saved` } variant={buttonVariant} iconPosition="right" disabled={saving} onClick ={ () => onSaveSetting()}>{ saveText }</Button>
		        	{ saving &&
		        		<Spinner/>
		        	}
		        </PanelBody>
	        </Panel>
        </>
	)
}
const adminWrapper = document.getElementById( "theme-wing-admin-main" )
render( <ThemeWingAdmin/>, adminWrapper )